import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@kernel/tools/services/auth.service";
import { EAccessType, RESTRICTED_ACCESS_TYPES } from "@app/shared/auth/enums/access-type.enum";

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();
  if (!token) return router.createUrlTree(["/auth/login"]);

  const accessType = parseAccessType(token);
  if (accessType && RESTRICTED_ACCESS_TYPES.includes(accessType)) {
    return router.createUrlTree(["/auth/change-temporary-password"]);
  }

  return true;
};

function parseAccessType(token: string): EAccessType | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.accessType ?? null;
  } catch {
    return null;
  }
}
